<template>
  <div>
    <Navbar />
    <Header />
    <About />
    <Feature />
    <Highlight />
    <Venue />
    <Location />
    <Cta />
    <Footer />
  </div>
</template>

<script>
import Navbar from "../components/TheNavbar";
import Header from "../components/TheHeader";
import About from "../components/TheAbout";
import Feature from "../components/TheFeature";
import Highlight from "../components/TheHighlight";
import Venue from "../components/TheVenue.vue";
import Location from "../components/TheLocation";
import Cta from "../components/TheCta";
import Footer from "../components/TheFooter";

export default {
  name: "Home",

  components: {
    Navbar,
    Header,
    About,
    Feature,
    Highlight,
    Venue,
    Location,
    Cta,
    Footer
  },
  created() {
    window.scrollTo(0,0);
  },
  mounted() {
    if(this.$route.hash !== '') {
      const el = document.querySelector(this.$route.hash);
      el && el.scrollIntoView();
    }
  }
};
</script>
